import { render, staticRenderFns } from "./MoreLogistics.vue?vue&type=template&id=5955e6a8&scoped=true&"
import script from "./MoreLogistics.vue?vue&type=script&lang=js&"
export * from "./MoreLogistics.vue?vue&type=script&lang=js&"
import style0 from "./MoreLogistics.vue?vue&type=style&index=0&id=5955e6a8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5955e6a8",
  null
  
)

export default component.exports